"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";

const MARKETING_PATHS = [
  "/",
  "/services",
  "/use-cases",
  "/synergy",
  "/legacy",
  "/privacy-policy",
  "/cookies",
];

function isMarketingPath(pathname: string | null): boolean {
  if (!pathname) return false;
  return MARKETING_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}

export function PostHogRecordingController() {
  const pathname = usePathname();
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return;
    if (isMarketingPath(pathname)) {
      posthog.stopSessionRecording();
    } else {
      posthog.startSessionRecording();
    }
  }, [pathname, posthog]);

  return null;
}
